import React from 'react';

import { Field } from 'react-final-form';

import { AutocompleteField } from 'src/components/finalForm';
import { useVerifierAutocomplete } from 'src/hooks/verifier';

type IntegrationVerifierFieldProps = {
  disabled?: boolean;
};

export const IntegrationVerifierField: React.FC<IntegrationVerifierFieldProps> = ({ disabled }) => {
  const verifierAutocompleteProps = useVerifierAutocomplete();

  return (
    <Field
      name="verifier"
      component={AutocompleteField}
      placeholder={disabled ? 'No verifier' : 'Search verifier by name'}
      fullWidth
      freeSolo={false}
      disabled={disabled}
      {...verifierAutocompleteProps}
    />
  );
};
